<template>
   <div class="table">
      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{TableModel.forms.attach_dashboard.title}}</div>
            <div class="subtitle">{{TableModel.forms.attach_dashboard.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="TableModel.forms.attach_dashboard.name" 
                  :forms="TableModel.forms.attach_dashboard.forms" 
                  :form_data="TableModel.forms.attach_dashboard.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateEventDashboard({ref: $refs[TableModel.forms.attach_dashboard.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Table v-bind="TableModel.tables.table.props" :data="tables" @on-action="handleActions">
         <template slot-scope="{ row }" slot="data_pull">
            <strong class="tx-small">{{ moment(row.last_data_pull).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="accessibility">
            <span class="tx-success bold" v-if="row.is_accessible">Accessible</span>
            <span class="tx-warning bold" v-else>Not Accessible</span>
         </template>
         <template slot-scope="{ row }" slot="unique_field">
            <span v-if="row.configs && row.configs.unique_field">{{row.configs.unique_field}}</span>
            <span v-else>N/A</span>
         </template>
      </Table>
   </div>
</template>

<script>
import table from "./table-stats.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('table')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('table',table,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         moment,
      };
   },
   computed: {
      ...mapGetters([
         'TableModel',
         'tables',
         'loading',
         'show_edit_modal',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'handleActions',
         'updateEventDashboard',
      ]),
   },
   async mounted(){
      utils.registerModule('table',table,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .table{
      .filter-data{
         background: $nav-top-color;
         margin: -10px -15px 30px -15px;
      }
      .tx-small{
         font-size: 12px;
      }
   }
</style>